import React, { useState } from 'react';
import axios from '../Axiosinstance';
import {
    Box,
    Button,
    TextField,
    Typography,
    Card,
    CardContent,
    Alert,
    CircularProgress,
    Grid,
    Avatar,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import {
    Email,
    Phone,
    Cake,
    Person,
    Assignment,
} from '@mui/icons-material';
import logopng from '.././images/logopng.png'



const StudentPage = () => {
    const [nric, setNric] = useState('');
    const [dob, setDob] = useState('');
    const [email, setEmail] = useState('');
    const [studentData, setStudentData] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await axios.get('/registrationadvances/student/marksheet',{ params: { nric, dob, email } });
            if (response.data) {
                setStudentData(response.data);
            } else {
                setError('No data found');
            }
        } catch (err) {
            // Check if backend error message exists
            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError('An unexpected error occurred');
            }
        } finally {
            setLoading(false);
        }
    };

    const getGrade = (totalMarks) => {
        if (totalMarks >= 90) return 'A';
        if (totalMarks >= 76) return 'B';
        if (totalMarks >= 60) return 'C';
        if (totalMarks >= 50) return 'D';
        if (totalMarks >= 49) return 'F';
        return 'F';
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: '#f0f2f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                py: 4,
            }}
        >
            <Box sx={{ maxWidth: 900, width: '100%' }}>
                {!studentData ? (
                    <Card
                        elevation={8}
                        sx={{
                            borderRadius: 4,
                            p: { xs: 3, sm: 5 },
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        }}
                    >

                        {/* Logo at top */}
                        <Box
                            sx={{
                                textAlign: 'center',
                                mb: 3,
                            }}
                        >
                            <img
                                src={logopng}
                                alt="Logo"
                                style={{
                                    maxWidth: 180,
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                }}
                            />
                        </Box>

                        <Typography
                            variant="h4"
                            component="h1"
                            gutterBottom
                            sx={{ fontWeight: '700', color: theme.palette.primary.main }}
                        >
                            Student Results
                        </Typography>
                        {/* <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 3 }}
            >
              Enter your NRIC, Date of Birth, and Email to fetch your details.
            </Typography> */}
                        <form onSubmit={handleSubmit} noValidate>
                            <TextField
                                label="NRIC"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={nric}
                                onChange={(e) => setNric(e.target.value.toUpperCase())}
                                required
                                inputProps={{ maxLength: 9, style: { letterSpacing: 1.2 } }}
                                placeholder="E.g., G2145015T"
                            />
                            <TextField
                                label="Date of Birth"
                                type="date"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={dob}
                                onChange={(e) => setDob(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                required
                            />
                            <TextField
                                label="Email"
                                type="email"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="E.g., example@gmail.com"
                            />
                            {error && (
                                <Alert severity="error" sx={{ mt: 2, fontWeight: 600 }}>
                                    {error}
                                </Alert>
                            )}
                            <Box
                                sx={{
                                    mt: 4,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    disabled={loading}
                                    sx={{
                                        minWidth: 140,
                                        fontWeight: '700',
                                        textTransform: 'none',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            boxShadow: '0 4px 15px rgba(25,118,210,0.4)',
                                        },
                                    }}
                                >
                                    {loading ? (
                                        <CircularProgress
                                            size={24}
                                            sx={{ color: 'white' }}
                                            thickness={5}
                                        />
                                    ) : (
                                        'Submit'
                                    )}
                                </Button>
                            </Box>
                        </form>
                    </Card>
                ) : (
                    <>
                        <Card
                            sx={{
                                mb: 4,
                                borderRadius: 4,
                                p: { xs: 3, sm: 4 },
                                boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                            }}
                        >
                            <Grid container spacing={3} alignItems="center">
                                <Grid item xs={12} sm={4} textAlign="center">
                                    <Avatar
                                        src={studentData?.student?.profileUrl}
                                        alt={studentData?.student?.name}
                                        sx={{
                                            width: 160,
                                            height: 160,
                                            mx: 'auto',
                                            border: `4px solid ${theme.palette.primary.main}`,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <Typography
                                        variant="h4"
                                        component="h2"
                                        gutterBottom
                                        sx={{ fontWeight: 700, }}
                                    >
                                        {studentData?.student?.name}
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                        <Email sx={{ verticalAlign: 'middle', mr: 1, color: theme.palette.primary.main }} />
                                        {studentData?.student?.email || 'N/A'}
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                        <Phone sx={{ verticalAlign: 'middle', mr: 1, color: theme.palette.primary.main }} />
                                        {studentData?.student?.phone || 'N/A'}
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                        <Person sx={{ verticalAlign: 'middle', mr: 1, color: theme.palette.primary.main }} />
                                        {studentData?.student?.gender || 'N/A'}
                                    </Typography>
                                    <Typography variant="body1">
                                        <Cake sx={{ verticalAlign: 'middle', mr: 1, color: theme.palette.primary.main }} />
                                        {studentData?.student?.dob
                                            ? new Date(studentData.student.dob).toLocaleDateString()
                                            : 'N/A'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Card>

                        <Card
                            sx={{
                                borderRadius: 4,
                                p: { xs: 2, sm: 3 },
                                boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    fontWeight: 700,
                                    display: 'flex',
                                    alignItems: 'center',

                                }}
                            >
                                <Assignment sx={{ mr: 1 }} />
                                Module Grades
                            </Typography>
                            <Paper elevation={0}>
                                <Table size="small" sx={{ minWidth: 320 }}>
                                    <TableHead sx={{ bgcolor: '#f5f7fa' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700 }}>Module</TableCell>
                                            <TableCell align="right" sx={{ fontWeight: 700 }}>
                                                Percentage (%) 
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontWeight: 700 }}>
                                                Grade
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Object.entries(studentData?.averageGradesPerModule || {}).map(([module, grade]) => (
                                            <TableRow key={module} hover>
                                                <TableCell>{module}</TableCell>
                                                <TableCell align="right">
                                                    <Chip
                                                        label={grade > 0 ? `${grade}%` : 'Pending'}
                                                        color={
                                                            grade >= 70
                                                                ? 'success'
                                                                : grade >= 40
                                                                    ? 'warning'
                                                                    : grade > 0
                                                                        ? 'error'
                                                                        : 'default'
                                                        }
                                                        size="small"
                                                    />
                                                </TableCell>
                                                <TableCell align="right">
                                                    {grade > 0 ? getGrade(grade) : '-'}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Card>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default StudentPage;
